import { api } from '@forbiz/web-kit'
import type { PointSummaryResponse } from '@forbiz/contracts'

/**
 * 주문 화면용 포인트 요약(BIZ-74). 잔액 + 회사 적립율. 담당자·관리자 모두 접근 가능
 * (내 회사 상세는 관리자 전용이라 담당자가 결제 UI에서 잔액을 못 보는 문제를 피한다).
 */
export const pointsApi = {
  summary: () => api.get<PointSummaryResponse>('/api/points/summary'),
}
